import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

function missingEnvKeys() {
  const required = [
    "REACT_APP_FIREBASE_API_KEY",
    "REACT_APP_FIREBASE_AUTH_DOMAIN",
    "REACT_APP_FIREBASE_PROJECT_ID",
    "REACT_APP_FIREBASE_STORAGE_BUCKET",
    "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
    "REACT_APP_FIREBASE_APP_ID",
  ];
  return required.filter((k) => !process.env[k]);
}

const app = (() => {
  const missing = missingEnvKeys();
  if (missing.length) {
    // eslint-disable-next-line no-console
    console.error(
      "[firebase] Missing env vars:",
      missing.join(", "),
      "— copy .env.example to .env and fill values (restart npm start)."
    );
  }
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const expectedProject = environment === "production" ? "carvakwt" : "carva-dev";
  if (firebaseConfig.projectId !== expectedProject) {
    throw new Error("Firebase environment mismatch. Use npm run start:testing or build:production.");
  }
  return getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
})();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

/** Analytics only runs in the browser when supported and measurementId is set */
export const analyticsPromise =
  typeof window !== "undefined" && firebaseConfig.measurementId
    ? isSupported().then((yes) => (yes ? getAnalytics(app) : null))
    : Promise.resolve(null);
